import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, formatErr } from "@/lib/api";

export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [err, setErr] = useState("");
  useEffect(() => { if (open) { setF({ current: "", next: "", confirm: "" }); setErr(""); } }, [open]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.next !== f.confirm) return setErr("Passwords do not match");
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Password changed");
      onOpenChange(false);
    } catch (e2) { setErr(formatErr(e2)); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="change-password-dialog" className="sm:max-w-sm" aria-describedby={undefined}>
        <DialogHeader><DialogTitle className="font-head text-2xl">Change password</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Input data-testid="cp-current-input" type="password" required placeholder="Current password" value={f.current} onChange={set("current")} />
          <Input data-testid="cp-new-input" type="password" required minLength={6} placeholder="New password (min 6)" value={f.next} onChange={set("next")} />
          <Input data-testid="cp-confirm-input" type="password" required minLength={6} placeholder="Confirm new password" value={f.confirm} onChange={set("confirm")} />
          {err && <p data-testid="cp-error" className="text-sm text-red-600">{err}</p>}
          <DialogFooter><Button data-testid="cp-submit-btn" className="bg-sky-600 hover:bg-sky-700">Update</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
